module.exports = __webpack_public_path__ + "static/media/done-3.73c8ae40.png";